export class ProductVariationPriceFormModel {
    costPrice: number = 0;
    listPrice: number = 0;
    sellPrice: number = 0;

    constructor(v?: ProductVariationPriceFormModel) {
        Object.assign(this, v)
    }
}
